import React from 'react'
import { Container, Form, Row, Col, Card, Button, Stack } from 'react-bootstrap'
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { useState } from "react";
import { auth } from './firebaseconfig';
import im from './Assets/coffie.jpg';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import './Signin.css'
function Signup() {
    const [name, setname] = useState("");
    const [email, setemail] = useState("");
    const [password, setpassword] = useState("");
    const navigate = useNavigate();
    const signUp = (e) => {
        e.preventDefault();
        createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                navigate('/Signin');
                toast.success("success");
                console.log(userCredential);
            })
            .catch((error) => {
                console.log(error);
                toast.error("error! please enter your details");
            });
    };
    return (
        <>
            <ToastContainer></ToastContainer>
            <div className='container-fluid'>
                <div className="imgl">
                    <img src={im} style={{ width: '100%', height: '100%' }} className='mt-3'></img>
                </div>
                <div className="crediential-container">
                    <div className="form">
                        <form onSubmit={signUp}>
                            <p className='header'>Signup/login</p>
                            <div className="form-inside">
                                <label>Enter your name<span>*</span></label>
                                <input type='name' value={name} onChange={(e) => setname(e.target.value)} className='input'></input>

                                <label>Email Address<span>*</span></label>
                                <input type='email' onChange={(e) => setemail(e.target.value)} className='input'></input>

                                <label>Password<span>*</span></label>
                                <input type='password' onChange={(e) => setpassword(e.target.value)} className='input' ></input>

                                <div className="buttons">
                                    <Button variant="success" type="submit" className='mt-2'>
                                        Signup
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

            </div>



        </>
    )
}

export default Signup